import * as Yup from 'yup';

const PracticeBillingValidationSchema = Yup.object().shape({
  practice_id: Yup.number().required('Practice is required'),
  bill_name: Yup.string().required('Bill name is required'),
  bill_npi: Yup.string()
    .required('NPI is required')
    .matches(/^\d{10}$/, 'NPI must be exactly 10 digits')
    .matches(/^\d+$/, 'NPI must contain only numbers'),
  bill_taxid: Yup.string()
    .required('Tax ID is required')
    .matches(/^\d{9}$/, 'Tax ID must be exactly 9 digits')
    .matches(/^\d+$/, 'Tax ID must contain only numbers'),
  bill_taxid_type: Yup.object().required('Tax ID type is required'),
  bill_taxonomy: Yup.string(),
  bill_id: Yup.string().matches(/^\d*$/, 'Atypical ID must contain only numbers'),
  bill_addr_1: Yup.string().required('Address line 1 is required'),
  bill_addr_2: Yup.string().required('Address line 2 is required. Enter N/A if not applicable'),
  bill_city: Yup.string().required('City is required'),
  bill_state: Yup.string().required('State is required'),
  bill_zip: Yup.string().trim().required('Zip code is required (5 digits)'),
  bill_phone: Yup.string().matches(/^\d*$/, 'Phone must contain only numbers'),
  practitioner_ids: Yup.array().min(1, 'Select at least one provider')
});

export default PracticeBillingValidationSchema;
